import { render, staticRenderFns } from "./single-property-page.vue?vue&type=template&id=8264a374&"
import script from "./single-property-page.vue?vue&type=script&lang=js&"
export * from "./single-property-page.vue?vue&type=script&lang=js&"
import style0 from "./single-property-page.vue?vue&type=style&index=0&id=8264a374&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports